import type { HTMLAttributes } from 'react'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  roomy?: boolean
}

export function Card({ roomy = false, className, ...rest }: CardProps) {
  const classes = ['ui-card']
  if (roomy) classes.push('ui-card--roomy')
  if (className) classes.push(className)
  return <div className={classes.join(' ')} {...rest} />
}
